import { useSyncExternalStore } from "react";

/**
 * 可观察的状态对象（对应 Swift 的 @Observable）：改完字段调用 changed()，
 * 同一轮里的多次修改合并成一次通知；界面用 useObserve(store) 订阅。
 */
export class Observable {
  private listeners = new Set<() => void>();
  private version = 0;
  private scheduled = false;

  readonly subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => { this.listeners.delete(listener); };
  };

  readonly getVersion = (): number => this.version;

  protected changed(): void {
    this.version += 1;
    if (this.scheduled) return;
    this.scheduled = true;
    queueMicrotask(() => {
      this.scheduled = false;
      for (const l of [...this.listeners]) l();
    });
  }

  /**
   * 立刻通知（不等到这一轮结束）：输入框绑着的字段必须用这个。
   * 否则 React 处理完 onChange 会先把输入框的值还原成旧值，中文输入法正在拼的字就被打断。
   */
  protected changedNow(): void {
    this.version += 1;
    for (const l of [...this.listeners]) l();
  }
}

export function useObserve(...stores: (Observable | undefined)[]): void {
  for (const s of stores) {
    // 订阅的对象个数在组件生命周期里不变
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useSyncExternalStore(s ? s.subscribe : noopSubscribe, s ? s.getVersion : zero);
  }
}

const noopSubscribe = () => () => {};
const zero = () => 0;
